import MoreChallengesView from "@memorang/ui/components/MoreChallengesView";
import { router } from "expo-router";
import useMoreChallenges from "../hooks/useMoreChallenges";

const MoreChallengesRouteContainer = () => {
	const { challenges, type, handlePressChallenge } = useMoreChallenges();

	return (
		<MoreChallengesView
			challenges={challenges}
			type={type!}
			handlePressChallenge={handlePressChallenge}
			onNavigateBack={() => router.back()}
		/>
	);
};

export default MoreChallengesRouteContainer;
